import { RotateCcw } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { callMark } from "@/lib/call-outcome";
import type { Cdr } from "@/lib/types";

/**
 * Which call of its cadence a dialer call was, beside the call's outcome: "Call 1", or "Redial 1
 * of 2" for a redial (ADR-105 in `platform`). On the Calls page, a contact's calls and timeline,
 * and a rep's own history, which all list a redial as the call it is.
 *
 * Draws nothing for a call the dialer did not place as a cadence call (`callMark`).
 */
export function CallMarkBadge({
  call,
}: {
  call: Pick<Cdr, "step_n" | "redial_n" | "redials_of">;
}) {
  const mark = callMark(call);
  if (mark === null) return null;
  return (
    <Badge tone={mark.redial ? "accent" : "neutral"} size="sm" title={mark.title}>
      {mark.redial && <RotateCcw className="size-2.5" aria-hidden />}
      {mark.label}
    </Badge>
  );
}
